<template>
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.43316 12L6.51864 11.087C3.12185 8.08696 0.900879 6.06522 0.900879 3.58696C0.900879 1.56522 2.46863 0 4.49363 0C5.60412 0 6.7146 0.521739 7.43316 1.36957C8.15171 0.521739 9.26219 0 10.3727 0C12.3977 0 13.9654 1.56522 13.9654 3.58696C13.9654 6.06522 11.7445 8.08696 8.34767 11.087L7.43316 12Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>